<template>
    <div class="container-fluid">
        <div class="head">
            <div class="super-title">已消费美团券明细</div>
            <router-link class="head-link" :to="{ name: 'ticketsingleProgram' }">返回“单个项目消费明细”</router-link>
        </div>
        <form class="form-horizontal" role="form">
            <div class="form-group">
                <label class="col-item  control-label">
                    <strong>项目名称：</strong>
                </label>
                <div class="col-text">
                    <a :href="programNameUrl+dealId+'.html'" target="_blank">{{dealName}}</a>
                </div>
            </div>
        </form>
        <div class="tips">门票已验证但却找不到？请确认是否选错了项目，或在
            <router-link :to="{ name: 'ticketallProgram' }">所有项目消费明细</router-link>
        </div>
        <div class="common-tip-blk">
            <span>
                <i class="F-glob F-glob-status-info"></i>
                <strong>合计</strong>{{useTimeStart}}累计验证
                <span class="text-danger">{{totalVerifyNum||0}}</span>张,撤销
                <span class="text-danger">{{totalRevocationNum||0}}</span>张,明细如下:
            </span>
            <span class="pull-right">
                <a :href="apiHost+generateUrl" target="_blank">下载明细记录</a>
            </span>
        </div>
        <div class="tablewrapper">
            <table class="table table-hover table-bordered">
                <thead>
                    <tr>
                        <th>订单号</th>
                        <th>操作时间</th>
                        <th>类型</th>
                        <th>电子票密码</th>
                        <th>操作数量</th>
                        <th>操作人</th>
                        <th>来源</th>
                        <th>消费者购买价</th>
                        <th>总价</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in detailList">
                        <td>
                            <a :href="otpHost+detailUrl+item.orderId">{{item.orderId}}</a>
                        </td>
                        <td>
                            {{item.operationTime|formdate}}
                        </td>
                        <td>
                            {{item.operationType == 1 ? '验证' : '撤销'}}
                        </td>
                        <td>
                            <strong>{{item.voucherCode}}</strong>
                        </td>
                        <td>
                            {{item.quantity}}
                        </td>
                        <td>{{item.operatorName}}</td>
                        <td>{{item.source}}</td>
                        <td>
                            {{item.sellPrice}}
                        </td>
                        <td>
                            {{item.totalPrice}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <p class="nodata" v-if="noData">未查询到匹配内容</p>
            <v-pagination class="pull-right" :current='current' :total='totalPage' :size="'md'" :first="false" :last="false" v-on:current-change="currentChangeFunc($event)">
            </v-pagination>
        </div>
    </div>
</template>
<script>
import api from 'api/verifyHistory'
import { formatDate as formdate} from 'helpers'
import { apiHost, otpHost } from 'config/env.conf.js'
export default {
    data() {
        return {
            options1: {
                "allowInput": true
            },
            msg: "",
            current: 1,
            perPageCount: 10,
            totalCount: 0,
            isTableLoading: false,
            useTimeEnd: '',
            useTimeStart: '',
            dealId: '',
            bizAccountAccess: 'web',
            noData: false,
            totalVerifyNum: 0,
            totalRevocationNum: 0,
            selectedIndex: 0,
            dealList: [],
            baseUrl: "/meilv/scs/account/v1/voucher/log/excel?",
            detailUrl: "#/ticket/order/ticket/detail?id=",
            programNameUrl: "https://www.meituan.com/deal/",
            searchInfo: false,
            apiHost: apiHost,
            otpHost: otpHost,
            formdate: formdate,
            detailList: [],
            dealName: ""
        };
    },
    created: function() {
        this.searchInfo = true;
        if (this.searchInfo) {
            this.getDetailList();
        }

    },
    filters: {
        formdate(time) {
            var date = new Date(time);
            return formdate(date, 'yyyy-MM-dd hh:mm:ss')
        }
    },
    computed: {
        totalPage() {
            return Math.ceil(this.totalCount / this.perPageCount);
        },
        generateUrl() {
            return this.baseUrl + "?dealId=" + this.dealId + "&useTimeStart=" + this.useTimeStart + "&useTimeEnd=" + this.useTimeEnd;
        },
    },
    methods: {
        alert(message) {
            this.$alert({
                title: '提示',
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        getFormateDate(date) {
            return this.formdate(date, 'yyyy-MM-dd hh:mm:ss');//为什么写成大写的HH就时间显示不出来
        },
        getDetailList() {
            if (this.searchInfo) {
                this.dealId = this.$route.params.dealId;
                this.useTimeStart = this.$route.params.useTimeStart;
                this.dealName = this.$route.params.dealName;
                this.useTimeEnd = this.useTimeStart;
            }
            console.log(this.dealId)
            this.isTableLoading = true;
            api.getAllConsumptionList({
                bizAccountAccess: this.bizAccountAccess,
                useTimeEnd: this.useTimeEnd,
                useTimeStart: this.useTimeStart,
                pageNo: this.current,
                pageSize: this.perPageCount,
                dealId: this.dealId
            }).then((response) => {
                this.isTableLoading = false;
                //console.log(response);
                if (response.status === 0) {
                    if (response.data) {
                        this.detailList = response.data.list;
                        this.totalVerifyNum = response.data.totalVerifyNum;
                        this.totalRevocationNum = response.data.totalRevocationNum;
                        this.totalCount = response.data.totalSize;
                    }
                    if (response.data.list.length === 0) {
                        this.noData = true;
                    }
                    else {
                        this.noData = false;
                    }
                } else {
                    this.alert(response.message || '接口返回信息有误');
                }
            }).catch((error) => {
                this.isTableLoading = false;
                this.consumptionList = [];
                this.alert(error);
            });
        },
        currentChangeFunc(data) {
            this.current = data.current;
            this.searchInfo = false;
            this.getDetailList();
        },
    }
}
</script>

<style lang="scss" scoped>
.container-fluid {
    margin-top: 20px;
    .head {
        position: relative;
        .super-title {
            font-size: 24px;
            line-height: 34px;
            padding: 15px 0;
            border-bottom: 1px dotted #eaeaea;
        }
        .head-link {
            position: absolute;
            right: 10px;
            bottom: 0;
        }
    }
    .tips {
        background-color: #F1F1F1;
    }
    .col-text {
        display: inline;
        cursor: pointer;
    }
    .time-filter {
        display: inline-block;
        padding: 3px 10px;
        margin: 0 5px;
        border: 2px solid #eee;
        color: #2bb8aa;
        cursor: pointer;
    }

    .active {
        background-color: #2bb8aa;
        color: white;
    }

    .col-item {
        position: relative;
        min-height: 1px;
        padding-left: 16px;
        padding-right: 15px;
        display: inline-block;
    }

    .common-tip-blk {
        border: 1px solid #eee;
        line-height: 40px;
        padding: 0 20px;
        margin-top: 10px;
        .pull-right {
            float: right!important;
            color: #2bb8aa;
            cursor: pointer;
        }
        .F-glob {
            color: #2bb8aa;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            text-decoration: none;
        }
        .F-glob-status-info:before {
            content: "\e90e";
        }
    }

    a[disabled] {
        cursor: not-allowed;
    }

    .nodata {
        width: 150px;
        margin: 0 auto;
    }
}
</style>





// WEBPACK FOOTER //
// detailConsumption.vue?7df49b64